import { memo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Container } from './styles/CenterLoadingStyles';
import { useSelector } from 'react-redux';

function CenterLoading() {
    const { showGlobalLoading } = useSelector((state) => state.uiReducer || {});

    // Si la modal de GlobalLoading ya está activa, no renderizamos el spinner de fondo para evitar duplicación
    if (showGlobalLoading) {
        return null;
    }

    return (
        <Container>
            <CircularProgress size='4em' style={{ color: '#202a5d' }} />
        </Container>
    );
}

export default memo(CenterLoading);